import { createFileRoute } from '@tanstack/react-router';

import { VStack } from '@/components/Layout';

import { Header } from './-header/-components';
import { ValueDetailOutletWithForm } from './_layout/-context/value-tab-form-context';
import { ValueFormStore } from './_layout/-store/store';

/**
 * Value 詳細画面の Layout。
 *
 * Issue 詳細の `_layout.tsx` と同じパターン。Phase 1B-FE で CForm / Zustand store /
 * ValueDetailOutletWithForm による section 単位編集を導入。
 */
export const Route = createFileRoute('/_stacktrace/values/$id/_layout')({
  component: Layout,
});

function Layout() {
  const store = ValueFormStore.createStore();
  return (
    <ValueFormStore.Provider value={store}>
      <VStack>
        <Header />
        <ValueDetailOutletWithForm />
      </VStack>
    </ValueFormStore.Provider>
  );
}
